import { css, cx } from "@emotion/css";
import { LayoutProps } from "@jsonforms/core";
import { PropsWithChildren, useContext, useEffect } from "react";

import { BaseLayoutContent } from "./BaseLayoutContent";
import { BaseLayoutContext } from "./BaseLayoutContext";
import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { shouldLayoutContentBeSummary } from "../utils";
interface Props extends PropsWithChildren, LayoutProps {
  testID?: string;
  className?: string;
}

export function BaseLayout(props: Props) {
  const { children, testID = "base-layout", ...contentProps } = props;

  const { setIsSummaryOverride } = useContext(CascadiaJsonFormContext);
  const parent = useContext(BaseLayoutContext);

  useEffect(() => {
    const setLayoutSummaryOverride = shouldLayoutContentBeSummary(
      props.uischema,
      props.data
    );
    if (setLayoutSummaryOverride) {
      setIsSummaryOverride?.(
        props.path + "." + (props.uischema as any).name,
        setLayoutSummaryOverride
      );
    }
  }, [props.path, props.uischema, props.data]);

  return (
    <BaseLayoutContext.Provider
      value={{
        ...contentProps,
        // If there is a parent layout that has visible set to false, hide this layout and all children as well.
        visible: parent.visible === false ? false : props.visible,
      }}
    >
      <div
        className={cx(css(styles.layout), props.className)}
        // Is this needed?
        // data-disabled={!props.enabled}
        data-hidden={!props.visible}
        data-testid={testID}
      >
        {children || <BaseLayoutContent />}
      </div>
    </BaseLayoutContext.Provider>
  );
}

const styles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
    "&[data-disabled=true]": { opacity: 0.5 },
    "&[data-hidden=true]": { display: "none" },
  }),
};
